import React, { useState, useEffect } from "react";
import EditLocationForm from "./EditLocationForm";
import AddLocationForm from "./AddLocationForm";

const LocationSearch = ({ refreshTrigger }) => {
  const [locations, setLocations] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showEditLocationForm, setShowEditLocationForm] = useState(false);
  const [showAddLocationForm, setShowAddLocationForm] = useState(false);

  const fetchLocations = () => {
    fetch('/api/locations')
      .then(r => {
        if (!r.ok) throw new Error('Failed to fetch locations');
        return r.json();
      })
      .then(data => {
        console.log('API /api/locations ->', data); // sanity check
        setLocations(data);
      })
      .catch(e => console.error('Error fetching locations:', e));
  };

  useEffect(() => {
    fetchLocations();
  }, [refreshTrigger]);

  const filteredLocations = locations.filter(loc =>
    (loc.location_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (loc.address?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (loc.status?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );

  const handleAddLocation = () => setShowAddLocationForm(true);
  const handleEditLocation = (location) => { setSelectedLocation(location); setShowEditLocationForm(true); };
  const handleSaveLocation = () => { fetchLocations(); setShowEditLocationForm(false); };
  const handleLocationAdded = () => { fetchLocations(); setShowAddLocationForm(false); };

  useEffect(() => {
  fetch("/api/locations")
    .then(r => r.json())
    .then(data => { console.log('locations', data); setLocations(data); });
}, []);


  return (
    <div className="user-list-container">
      <h2>Location List</h2>

      <div>
        <label>Search Locations:</label>
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="button-container">
        <button className="add-location-button" onClick={handleAddLocation}>Add Location</button>
      </div>

      <div className="UserList-container">
        <table>
          <thead>
            <tr>
              <th>Location Name</th>
              <th>Address</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredLocations.length > 0 ? (
              filteredLocations.map((location) => (
                <tr key={location.location_id}>
                  <td>{location.location_name}</td>
                  <td className="address">{location.address}</td>
                  <td>{location.status}</td> {/* <-- correct field */}
                  <td>
                    <button onClick={() => handleEditLocation(location)}>Edit</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No Location match your search.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showEditLocationForm && selectedLocation && (
        <EditLocationForm
          location={selectedLocation}
          onClose={() => setShowEditLocationForm(false)}
          onSave={handleSaveLocation}
        />
      )}

      {showAddLocationForm && (
        <AddLocationForm
          onClose={() => setShowAddLocationForm(false)}
          onLocationAdded={handleLocationAdded}
        />
      )}
    </div>
  );
};

export default LocationSearch;
